export default "__VITE_ASSET__BQi$SBOM__"